import React, { createContext, useState } from 'react';
import { IChildren } from '../components/layout/index'

interface IDataContext {
    filtroData?: any
    setFiltroData?: (e: any) => void
}

interface IData {
    children?: any
    filtroData?: any
    setFiltroData?: (e: any) => void
}

interface IEventos {
    children?: any
    filtroEventos?: any
    setFiltroEventos?: (e: any) => void
}

export const FiltroDataContext = createContext<IData>({});

export default function FiltroDataProvider(props: IChildren) {
    const [filtroData, setFiltroData] = useState<any[]>();

    return (
        <FiltroDataContext.Provider value={{ filtroData, setFiltroData }}>
            {
                props.children
            }
        </FiltroDataContext.Provider>
    )
}

export const FiltroEventosContext = createContext<IEventos>({}); 

export function FiltroEventosProvider(props: IChildren){
    const [filtroEventos, setFiltroEventos] = useState<any[]>();

    return (
        <FiltroEventosContext.Provider value={{filtroEventos, setFiltroEventos}}>
            {
                props.children
            }
        </FiltroEventosContext.Provider>
    )
}